<template>
  <PlatformLayout :useOverlay="overlay">
    <v-card rounded max-width="1366" class="d-block mx-auto">
      <v-card-title>
        <v-row>
          <v-col cols="12" md="6">
            <h5 class="text-h5 font-weight-bold text-left">
              Servicios&nbsp;<v-icon large>mdi-hammer-screwdriver</v-icon>
            </h5>
          </v-col>
          <v-col cols="12" md="6" class="d-flex justify-end">
            <v-btn color="primary" class="mr-lg-1" @click="openAddDialog">
              <v-icon>mdi-plus</v-icon>Agregar
            </v-btn>
            <v-btn @click="importar" class="mr-2">
              <v-icon>mdi-file-excel-outline</v-icon>Importar Excel
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :search="search"
          :headers="headers"
          :items="servicios"
          :items-per-page="20"
          :footer-props="{
            itemsPerPageText: 'El. por página',
            itemsPerPageAllText: 'Todo',
            itemsPerPageOptions: ippoptions,
          }"
          no-results-text="No hay resultados"
          no-data-text="No hay datos para mostrar"
        >
          <template v-slot:top>
            <v-text-field v-model="search" label="Buscar"></v-text-field>
          </template>
          <template v-slot:item.attributes.codigo="{ item }">
            <div>{{ item.attributes.codigo | uppercase }}</div>
          </template>
          <template v-slot:item.attributes.precio_lista="{ item }">
            <div>{{ item.attributes.precio_lista || 0 | currency }}</div>
          </template>
          <template v-slot:item.attributes.precio_unitario="{ item }">
            <div>{{ item.attributes.precio_unitario || 0 | currency }}</div>
          </template>
          <template v-slot:item.attributes.st_costo="{ item }">
            <div>{{ item.attributes.st_costo || 0 | currency }}</div>
          </template>
          <template v-slot:item.acciones="{ item }">
            <v-btn
              class="ma-1"
              color="accent"
              fab
              small
              @click="openDialog(item)"
              ><v-icon>mdi-pencil</v-icon></v-btn
            >
            <v-btn
              class="ma-1"
              color="warning"
              fab
              small
              @click="requestDeleteService(item)"
              ><v-icon>mdi-delete</v-icon></v-btn
            >
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <ServiceDialog
      :trigger="dialog"
      :service="selectedService"
      @onAddRequest="addService"
      @onEditRequest="editService"
      @onCancel="resetDialog"
    />
    <ConfirmationDialog
      :dialog_ref="deleteDialog"
      :dialogTitle="'Eliminar servicio'"
      :dialogMsg="'¿Está seguro que desea elimnar este servicio? Esta acción no se puede deshacer.'"
      :confirmBtnText="'Eliminar'"
      :confirmBtnIcon="'mdi-delete'"
      :confirmBtnStyle="'warning'"
      @onConfirm="deleteService"
      @onCancel="resetDialog"
    />
  </PlatformLayout>
</template>

<script>
import PlatformLayout from "@/components/PlatformLayout.vue";
import ServiceDialog from "@/components/Servicios/ServiceDialog.vue";
import ConfirmationDialog from "@/components/ConfirmationDialog.vue";
import { httpGet, httpPost, httpPut, httpDelete } from "@/services/apiService";

export default {
  name: "Servicios",
  components: {
    PlatformLayout,
    ServiceDialog,
    ConfirmationDialog,
  },
  data: () => ({
    overlay: false,
    search: "",
    headers: [
      {
        text: "Código",
        align: "center",
        sortable: true,
        value: "attributes.codigo",
      },
      {
        text: "Descripción",
        align: "center",
        sortable: true,
        value: "attributes.descripcion",
      },
      {
        text: "Unidad",
        align: "center",
        sortable: true,
        value: "attributes.unidad",
      },
      {
        text: "Precio de lista",
        align: "center",
        sortable: true,
        value: "attributes.precio_lista",
      },
      {
        text: "Acciones",
        align: "center",
        sortable: false,
        value: "acciones",
      },
    ],
    servicios: [],
    ippoptions: [10, 20, 30, 40, 50, -1],
    sheets: [],
    dialog: false,
    selectedService: null,
    deleteDialog: false,
    selectedForDeletion: null,
  }),
  methods: {
    async getData() {
      this.overlay = true;
      const { data } = await httpGet("/servicios");
      this.servicios = data?.data;
      this.overlay = false;
    },
    importar() {
      this.$router.push({ path: "/platform/servicios/importacion-servicios" });
    },
    openAddDialog() {
      this.dialog = true;
    },
    openDialog(item) {
      this.selectedService = item;
      this.dialog = true;
    },
    async addService(event) {
      const { data } = await httpPost("/servicios", {
        data: event,
      }).catch((err) => {
        this.$toasted.show(
          "Ha ocurrido un error al agregar el servicio. Intente de nuevo más tarde.",
          { type: "error" }
        );
        this.resetDialog();
        return;
      });

      this.$toasted.show("Servicio agregado. Actualizando el catálogo...", {
        type: "success",
      });
      this.getData();
      this.resetDialog();
    },
    async editService(event) {
      const { data } = await httpPut("/servicios/" + event.id, {
        data: event,
      }).catch((err) => {
        this.$toasted.show(
          "Ha ocurrido un error al agregar el servicio. Intente de nuevo más tarde.",
          { type: "error" }
        );
        this.resetDialog();
        return;
      });

      this.$toasted.show("Servicio agregado. Actualizando el catálogo...", {
        type: "success",
      });
      this.getData();
      this.resetDialog();
    },
    async deleteService() {
      const { data } = await httpDelete(
        "/servicios/" + this.selectedForDeletion.id
      ).catch((err) => {
        this.$toasted.show(
          "Ha ocurrido un error al agregar el servicio. Intente de nuevo más tarde.",
          { type: "error" }
        );
        this.resetDialog();
        return;
      });

      this.$toasted.show("Servicio agregado. Actualizando el catálogo...", {
        type: "success",
      });
      this.getData();
      this.resetDialog();
    },
    requestDeleteService(event) {
      this.selectedForDeletion = event;
      this.deleteDialog = true;
    },
    resetDialog() {
      this.dialog = false;
      this.deleteDialog = false;
      this.selectedService = null;
      this.selectedForDeletion = null;
    },
  },
  created() {
    this.getData();
  },
};
</script>
